import React from "react";
import styled from "styled-components";
import { ReactComponent as LogTitle } from "../../../assets/icons/LogoTitle.svg";

import { MIN_MORNITOR_WIDTH } from "../../constants";

const LogoTitleWrapper: React.FC = () => {
  return (
    <StyledTitleWrapper>
      <LogTitle />
    </StyledTitleWrapper>
  );
};

export default LogoTitleWrapper;

const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  width: 100%;
  padding: 0px 40px;
  margin: 40px;
  color: white;

  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    margin-top: 20px;
    height: 40px;
  }
`;
